/* ============================================================================
   Header · Navegación adaptativa "priority+" (botón "Más")
   ----------------------------------------------------------------------------
   Mide el ancho disponible del menú de escritorio (.main-nav.desktop) y mueve
   los ítems que no caben a un desplegable "Más", para que el menú NUNCA baje a
   una segunda línea. Al ensanchar la ventana, los ítems vuelven a su sitio.

   Vanilla JS (sin jQuery). Se incluye con `defer` desde main-navigation.liquid.
   No modifica archivos sensibles (styles.css / header.liquid). El estilo del
   panel vive en header-nav-overflow.css.
   ============================================================================ */
(function () {
  'use strict';

  function init(nav) {
    if (!nav || nav.__ccNavOverflowInit) return;
    var ul = nav.querySelector(':scope > ul');
    var moreItem = ul ? ul.querySelector(':scope > .nav-item--more') : null;
    var moreList = moreItem ? moreItem.querySelector('.nav-more-list') : null;
    if (!ul || !moreItem || !moreList) return;
    nav.__ccNavOverflowInit = true;

    var link = moreItem.querySelector('.nav-item-link');
    var closeTimer = null;
    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

    // --- Medición y reubicación ---------------------------------------------
    function realItems() {
      return Array.prototype.filter.call(ul.children, function (li) {
        return li.classList.contains('nav-item') &&
               !li.classList.contains('nav-item--more') &&
               !li.classList.contains('logo-item');
      });
    }

    function moveAllBack() {
      while (moreList.firstElementChild) {
        ul.insertBefore(moreList.firstElementChild, moreItem);
      }
      moreItem.hidden = true;
    }

    function needed(withMore) {
      var total = 0;
      var items = realItems();
      for (var i = 0; i < items.length; i++) total += items[i].offsetWidth;
      if (withMore) total += moreItem.offsetWidth;
      return total;
    }

    function available() {
      return ul.clientWidth;
    }

    function layout() {
      // Si el nav de escritorio está oculto (vista móvil), no intervenir.
      if (nav.offsetParent === null) {
        moveAllBack();
        return;
      }
      moveAllBack();
      nav.classList.add('cc-nav-ready');

      if (needed(false) <= available()) {
        closeMore();
        return;
      }

      moreItem.hidden = false;
      var items = realItems();
      var guard = 0;
      while (needed(true) > available() && items.length > 0 && guard < 100) {
        moreList.insertBefore(items.pop(), moreList.firstElementChild);
        guard++;
      }
      if (moreList.children.length === 0) {
        moreItem.hidden = true;
      }
    }

    // --- Abrir / cerrar el panel "Más" --------------------------------------
    function openMore() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      moreItem.classList.add('is-open');
      if (link) link.setAttribute('aria-expanded', 'true');
    }
    function closeMore() {
      moreItem.classList.remove('is-open');
      if (link) link.setAttribute('aria-expanded', 'false');
    }
    function toggleMore() {
      moreItem.classList.contains('is-open') ? closeMore() : openMore();
    }

    if (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        // En equipos con hover, el mouseenter ya gestiona abrir/cerrar (igual
        // que el resto de dropdowns del tema); el click solo evita el salto de
        // "#". En táctil (sin hover) el click alterna el panel.
        if (!canHover) toggleMore();
      });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); toggleMore(); }
        else if (e.key === 'Escape' || e.key === 'Esc') { closeMore(); link.focus(); }
      });
    }
    if (canHover) {
      moreItem.addEventListener('mouseenter', openMore);
      moreItem.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(closeMore, 180);
      });
    }
    document.addEventListener('click', function (e) {
      if (!moreItem.contains(e.target)) closeMore();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closeMore();
    });

    // --- Recalcular en cambios de tamaño ------------------------------------
    var rafId = null;
    function schedule() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(layout);
    }

    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    window.addEventListener('orientationchange', schedule);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedule).catch(function () {});
    }
    // Observamos el CONTENEDOR (no el nav) para que mover ítems no dispare un
    // bucle: el ancho del contenedor depende del viewport, no de nuestro DOM.
    if ('ResizeObserver' in window) {
      var container = nav.closest('.nav-container') || nav.parentElement || nav;
      var ro = new ResizeObserver(schedule);
      ro.observe(container);
    }

    layout();
  }

  function boot() {
    var navs = document.querySelectorAll('.main-nav.desktop');
    for (var i = 0; i < navs.length; i++) init(navs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
